<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
      name: 'App',
      data(){
          return {

          }
      },
      created(){

      },
      mounted(){
          var that = this;
          window.onscroll = function(){
              var scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滑动宽度/高度
              if(scrollTop > 173){
                  if(!that.$store.state.fixed){
                      that.$store.state.fixed = true;
                  }
              } else {
                  that.$store.state.fixed = false;
              }
          };
      },
      methods: {

      },
      components: {
      }

  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif, 'Microsoft YaHei';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    /*width: 1280px;*/
    /*min-width: 1280px;*/
  }
  .container{
    margin: 0 auto;
  }
  .text-center{
    text-align: center;
  }
  .text-right{
    text-align: right;
  }
  .text-left{
    text-align: left;
  }
  .flex-row{
    display: flex;
    flex-direction: row;
  }
  .col-5 {
    width: 5%;
  }
  .col-10 {
    width: 10%;
  }
  .col-15 {
    width: 15%;
  }
  .col-20 {
    width: 20%;
  }
  .col-25 {
    width: 25%;
  }
  .col-50 {
    width: 50%;
  }
  .col-30 {
    width: 30%;
  }
  .col-33 {
    width: 33%;
  }
  .col-34 {
    width: 34%;
  }
  .col-35 {
    width: 35%;
  }
  .col-40 {
    width: 40%;
  }
  .col-45 {
    width: 45%;
  }
  .col-55 {
    width: 55%;
  }
  .col-60 {
    width: 60%;
  }
  .col-65 {
    width: 65%;
  }
  .col-67 {
    width: 67%;
  }
  .col-70 {
    width: 70%;
  }
  .col-75 {
    width: 75%;
  }
  .col-80 {
    width: 80%;
  }
  .col-85 {
    width: 85%;
  }
  .col-90 {
    width: 90%;
  }
  .col-95 {
    width: 95%;
  }
  .col-100 {
    width: 100%;
  }
  .relate, .relative{
    position: relative;
  }
  .pointer{
    cursor: pointer;
  }
  /* 超出显示省略号 */
  .overflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /* 超出2行显示省略号 */
  .overflow2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .overflow3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  a {
    text-decoration: none;
    background: transparent;
    color: inherit;
    -webkit-tap-highlight-color: transparent;
  }
  .btn-default, .btn-primary{
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    border-radius: 2px;
    border: 0;
    user-select: none;
  }
  .alert{
    width: 50%;
    text-align: left;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue